// src/components/common/StatCard.jsx
import React from 'react';

/**
 * Generic stat card component for the overview page.
 *
 * Props:
 *   icon      — Bootstrap icon class string (e.g. 'bi-activity')
 *   label     — Short label text
 *   value     — Primary numeric/string value to display
 *   color     — CSS color value applied to icon and accent (e.g. 'var(--accent-green)')
 *   subtitle  — Optional secondary line below the value
 *   pulse     — When true, adds a pulsing dot indicator next to the label
 */
const StatCard = ({ icon, label, value, color, subtitle, pulse = false }) => {
  return (
    <div className="theme-card stat-card">
      <div className="stat-card-inner">
        {/* Icon */}
        <div className="stat-card-icon" style={{ color }}>
          <i className={`bi ${icon}`} />
        </div>

        {/* Body */}
        <div className="stat-card-body">
          {/* Label row */}
          <div className="stat-card-label">
            {pulse && (
              <span
                className="stat-pulse-dot"
                style={{ backgroundColor: color }}
                aria-hidden="true"
              />
            )}
            <span style={{ color: 'var(--text-muted)' }}>{label}</span>
          </div>

          {/* Value */}
          <div className="stat-card-value" style={{ color }}>
            {value ?? '—'}
          </div>

          {/* Subtitle */}
          {subtitle && (
            <div className="stat-card-subtitle">{subtitle}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default StatCard;
